// extracted by mini-css-extract-plugin
export default {"wrapper":"BlogPostLoading-wrapper-nWJ","header":"BlogPostLoading-header-eQm"};